import { useEffect, useState } from "react";
const LOGO_SRC = "/logo-ui.png";
export const LogoPlate = ({ className = "" }) => (
    <img
        src={LOGO_SRC}
        alt="DESAMATIC — Gate · Door · Park Openers"
        width="360"
        height="148"
        decoding="async"
        className={`h-8 w-auto ${className}`}
    />
);

export const NavLogo = () => {
    const [scrolled, setScrolled] = useState(false);

    useEffect(() => {
        const onScroll = () => setScrolled(window.scrollY > 24);
        onScroll();
        window.addEventListener("scroll", onScroll, { passive: true });
        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    return (
        <img
            src={LOGO_SRC}
            alt="DESAMATIC — Gate · Door · Park Openers"
            width="360"
            height="148"
            decoding="async"
            fetchPriority="high"
            className={`w-auto transition-[height] duration-500 ease-out drop-shadow-[0_2px_16px_rgba(0,0,0,0.45)] ${
                scrolled ? "h-9 md:h-11" : "h-12 md:h-16"
            }`}
        />
    );
};

export default function Logo() {
    return <LogoPlate className="h-7 md:h-8" />;
}
